<template>
  <div>
    <!-- 确认离开   -->
    <div v-if="openType === 0">
      <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="姓名"><span>{{addEditForm.name}}</span></el-form-item>
        <el-form-item label="电话"><span>{{addEditForm.phone}}</span></el-form-item>
        <el-form-item label="人数"><span>{{addEditForm.peopleCount}}</span></el-form-item>
        <el-form-item label="来访时间"><span>{{addEditForm.visitTime}}</span></el-form-item>
        <el-form-item label="离开时间" prop="leaveTime">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.leaveTime"
                          type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <!-- add edit   -->
    <div v-else>
      <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input :disabled="openType === 2" v-model="addEditForm.name" placeholder="姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idNum">
              <el-input :disabled="openType === 2" v-model="addEditForm.idNum" placeholder="身份证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input :disabled="openType === 2" v-model="addEditForm.phone" placeholder="输入电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人数" prop="peopleCount">
              <el-input :disabled="openType === 2" v-model="addEditForm.peopleCount" placeholder="输入人数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来访时间" prop="visitTime">
              <el-date-picker v-fixZoom :disabled="openType === 2" style="width: 100%" v-model="addEditForm.visitTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="离开时间" prop="leaveTime">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.leaveTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="来访事由" prop="reason">
          <el-input :disabled="openType === 2" type="textarea" :rows="2" v-model="addEditForm.reason" placeholder="输入来访事由"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()"><span>取消</span></div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')"><span>确定</span></div>
        </el-col>
      </el-row>
<!--      <el-row v-else style="margin: 0 20px">-->
<!--        <div class="cancel-btn" style="float: right" @click="closeAddEdit()"><span>关闭</span></div>-->
<!--      </el-row>-->
    </div>
  </div>
</template>

<script>
import {createpersonaccesslog, updatepersonaccesslog} from '../../../api/yanglaoyuan/personaccesslog'

export default {
  name: 'addEditRegistInOut',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    registObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      espId: 0,
      espName: '',
      // 打开类型 0查看 1新增 2编辑
      openType: 0,
      row: '',
      pickerOptions: {},

      addEditForm: {
        name: '',
        phone: '',
        idNum: '',
        reason: '',
        peopleCount: '',
        visitTime: '',
        leaveTime: ''
      },
      addEditRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        // idNum: [{ required: true, message: '请选择身份证号', trigger: 'change' }],
        reason: [{required: true, message: '请选择来访事由', trigger: 'change'}],
        peopleCount: [{required: true, message: '请选择来访人数', trigger: 'change'}],
        visitTime: [{required: true, message: '请选择来访时间', trigger: 'change'}],
        leaveTime: [{required: true, message: '请选择离开时间', trigger: 'change'}]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname

      this.openType = this.registObj.openType
      this.row = this.registObj.row

      if (this.openType !== 1) {
        this.addEditForm.name = this.row.name
        this.addEditForm.phone = this.row.phone
        this.addEditForm.idNum = this.row.id_num
        this.addEditForm.reason = this.row.reason
        this.addEditForm.peopleCount = this.row.people_count
        this.addEditForm.visitTime = this.row.visit_time
        this.addEditForm.leaveTime = this.row.level_time
      }
      console.log(this.row)
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.openType === 1) {
            this.sendAdd()
          } else if (this.openType === 2 || this.openType === 0) {
            this.sendEdit()
          }
        }
      })
    },
    sendAdd () {
      let data = {
        e_id: this.eId,
        name: this.addEditForm.name,
        phone: this.addEditForm.phone,
        id_num: this.addEditForm.idNum,
        reason: this.addEditForm.reason,
        people_count: this.addEditForm.peopleCount !== '' ? parseInt(this.addEditForm.peopleCount) : this.addEditForm.peopleCount,
        visit_time: this.addEditForm.visitTime,
        level_time: this.addEditForm.leaveTime
      }
      createpersonaccesslog(data).then(res => {
        this.$notify({title: '成功', message: '成功新建出入登记', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let data = {
        id: this.row.id,
        e_id: this.eId,
        name: this.addEditForm.name,
        phone: this.addEditForm.phone,
        id_num: this.addEditForm.idNum,
        reason: this.addEditForm.reason,
        people_count: this.addEditForm.peopleCount !== '' ? parseInt(this.addEditForm.peopleCount) : this.addEditForm.peopleCount,
        visit_time: this.addEditForm.visitTime,
        level_time: this.addEditForm.leaveTime
      }
      if (this.openType === 0) {
        data.visit_tag = 1
      }
      updatepersonaccesslog(data).then(res => {
        if (this.openType === 0) {
          this.$notify({title: '成功', message: '成功离开', type: 'success', duration: 2000})
        } else {
          this.$notify({title: '成功', message: '成功修改出入登记', type: 'success', duration: 2000})
        }
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditRegistInOut.vue